import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function convertFilterString(str) {
  const [name, values] = str.split("=");
  const filterValues = decodeURIComponent(values).split("%2C");
  return { name, filter: filterValues };
}

export const getLocalStorageItem = key => {
  const value = localStorage.getItem(key);
  return JSON.parse(value);
};
